import { datadogLogs, LogsGlobal } from "@datadog/browser-logs";
import { DefaultEnv } from "store/env";
import { LoggerOptions } from "./LoggerOptions";

declare global {
  interface Window {
    datadogLogs: LogsGlobal;
  }
}

export type Logger = typeof datadogLogs.logger;

const { dataDogToken, envName, version } = DefaultEnv;
if (dataDogToken) {
  datadogLogs.init({
    clientToken: dataDogToken,
    forwardErrorsToLogs: false, //We lose access to console.error, but we gain that it will not log Aborted fetches, which flood the errors.
    sampleRate: 100,
    env: envName,
    version
  });
} else {
  datadogLogs.init({
    clientToken: "invalid",
    datacenter: undefined
  });
}

datadogLogs.logger.setHandler(LoggerOptions.handler);
datadogLogs.logger.setLevel(LoggerOptions.level);

datadogLogs.setLoggerGlobalContext({ env: envName });
//Rum and logs are very insistent on being initialized just once.
//Putting them in the React lifecycle at all causes strange issues around init.
//Avoid that and make them both static.
datadogLogs.logger.info("Init DD logs", LoggerOptions);
window.datadogLogs = datadogLogs;
